<!--
 * @Author: wangjiaxiang
 * @Date: 2022-08-20 19:20:10
 * @LastEditTime: 2022-10-14 10:43:48
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description:
 * @FilePath: /大增长星妈会C端/xmh-front-content/src/components/home/userCardSearch/index.vue
 *
-->
<template>
  <div class="usercard-search" :class="{ 'show-editTips': showeditTips }">
    <img
      class="back-icon"
      @click.stop="goBack"
      src="@/assets/images/powderedMilk/goback.png"
      alt=""
    />
    <van-popover
      v-model="getBabyFlag"
      :get-container="getContainer"
      :offset="((loginFlag || !editFlag) && [-16, 8]) || [-22, 8]"
      placement="bottom-start"
    >
      <div class="baby-list" v-if="babyInfo.length > 0">
        <p class="title">我的状态</p>
        <ul class="baby-ul-list">
          <li
            class="baby-item"
            v-for="babyItem in babyInfo"
            :key="babyItem.id"
            @click="switchBabyInfo(babyItem)"
          >
            <img
              v-if="babyItem.tag_id == 1"
              src="@/assets/images/nweHome/beiyun-icon.png"
            />
            <img
              v-else-if="babyItem.tag_id == 2"
              src="@/assets/images/nweHome/huaiyun-icon.png"
            />
            <img
              src="@/assets/images/home/type3.png"
              v-else-if="babyItem.tag_id > '2' && babyItem.sex == 'M'"
            />
            <img
              src="@/assets/images/home/type4.png"
              alt=""
              v-else-if="babyItem.tag_id > '2' && babyItem.sex == 'F'"
            />
            <img
              src="@/assets/images/home/type4.png"
              alt=""
              v-else-if="babyItem.tag_id > '2' && babyItem.sex == 'O'"
            />
            <img
              src="@/assets/images/home/type4.png"
              alt=""
              v-else-if="babyItem.tag_id > '2' && babyItem.sex == ''"
            />
            <div class="item-right">
              <!-- 备孕显示 -->
              <p class="item-info" v-if="babyItem.tag_id == 1">
                <span class="nice-name">备孕</span>
              </p>
              <!-- 非备孕 -->
              <p class="item-info" v-else>
                <span class="nice-name">{{
                  babyItem.tag_id == 2 ? '怀孕中' : babyItem.nick || '鹤小宝'
                }}</span>
                <span>{{
                  babyItem.num == 1 ? babyDays.firsttime : babyDays.secondtime
                }}</span>
              </p>
              <img
                v-if="currentBabyInfo && currentBabyInfo.num == babyItem.num"
                src="@/assets/images/nweHome/pop-checked.png"
                alt="选中"
              />
            </div>
          </li>
        </ul>
        <div class="button glBaby" @click="glBaby">宝宝管理</div>
      </div>
      <!-- 未登录、登录未定制，  显示提示信息 -->
      <div class="editTips-pop" v-else>
        <span>添加宝宝月龄，获取专属于您的奶粉定制知识 </span>
        <img
          @click="closeEditTips"
          src="@/assets/images/icon/close1.png"
          alt=""
        />
      </div>
      <template #reference>
        <div class="current-state" @click="openBabyList">
          <p>
            <span>{{ currentBabyName }}</span>
            <span class="baby-month-info" v-if="currentBabyMonth"
              >（{{ currentBabyMonth }}）</span
            >
          </p>
          <img src="@/assets/images/powderedMilk/down-arrow.png" alt="" />
        </div>
      </template>
    </van-popover>
    <div class="btn_box">
      <img
        class="icon search-icon"
        src="@/assets/images/powderedMilk/search-icon.png"
        alt="搜索"
        @click="toSearch"
      />
      <img
        class="icon"
        src="@/assets/images/powderedMilk/share-icon.png"
        alt="分享"
        @click="$emit('clickSharehandler')"
      />
    </div>
  </div>
</template>
<script>
import Index from './js/index.js'
export default Index

</script>
<style lang="less" scoped>
@import './less/index.less';
</style>
<style lang="less">
@import './less/popover-content.less';
</style>
